import WireframeNavMenuBase from './WireframeNavMenuBase';
import wireframeNavHorizontal from '../assets/icons/wireframeNavHorizontal.svg';

class WireframeNavMenuHorizontal extends WireframeNavMenuBase {
  constructor(fabricObject) {
    fabricObject.layout = 'row';
    super(fabricObject);
  }

  static iconSvg() {
    return wireframeNavHorizontal;
  }
}

export default WireframeNavMenuHorizontal;
